import heart from "./images/сердечко-дата.png";
import photos from "./images/photos.png";
import { motion } from "framer-motion";

export const Footer = () => {
  return (
    <footer className="w-full px-5 sm:px-10 pb-5">
      <div className="relative flex flex-col items-center gap-5">
        <img src={photos} alt="Наши фото" className="h-auto w-full" />

        <div className="mt-2 flex flex-col items-center gap-5">
          <p
            className="uppercase font-bold text-3xl leading-0"
            style={{ fontFamily: "ofont_flow" }}
          >
            До встречи!
          </p>

          <div className="flex flex-row items-center gap-3">
            <p className="text-[var(--secondary-soft)]">
              С любовью, Валера и Маша
            </p>

            <motion.img
              src={heart}
              alt="Сердечко"
              className="h-6 w-6"
              animate={{ rotate: [0, -10, 10, -10, 10, 0] }}
              transition={{
                duration: 2.3,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            />
          </div>
        </div>
      </div>
    </footer>
  );
};
